/**
 * RelatedCallsDisplay.tsx
 * Talkroute
 *
 * Created by Vel Genov on 2/19/19
 * Copyright (c) 2019 Talkroute. All right reserved.
 */

import React from "react";
import PropTypes from "prop-types";
import { Grid } from "semantic-ui-react";

import callTypeIcon from "./CallTypeIcon";
import { formatSecondsWithQualifier } from "../../helpers/converters";

const removeGridPadding = { paddingTop: "0px", paddingBottom: "0px" };

/**
 * A functional React component that displays a passed in list of related calls
 *
 * @param {*} props
 */
export default function RelatedCallsDisplay(props) {
  const { relatedCalls } = props;

  let returnValue: any = <></>;
  if (Array.isArray(relatedCalls) && relatedCalls.length > 0) {
    returnValue = relatedCalls.map((entry) => {
      const { type, duration, id } = entry;
      const callResultFormatted = entry.getCallResultFormatted();
      const date = entry.getFormattedDate();
      return (
        <RenderRelatedCallLineItem
          key={id}
          type={type}
          date={date}
          callResult={entry.callResult}
          callResultFormatted={callResultFormatted}
          duration={duration}
        />
      );
    });
  }

  return returnValue;
}

/**
 * Display a related call line item
 *
 * @param {*} props
 */
function RenderRelatedCallLineItem(props) {
  const { type, date, callResult, callResultFormatted, duration } = props;
  return (
    <Grid style={{ paddingBottom: "14px" }}>
      <Grid.Column style={{ ...removeGridPadding }} width={2}>
        {callTypeIcon({ type, callResult, hovering: false })}
      </Grid.Column>
      <Grid.Column
        style={{ ...removeGridPadding }}
        width={5}
        className="text-normal"
      >
        {date}
      </Grid.Column>
      <Grid.Column
        style={{ ...removeGridPadding }}
        width={4}
        className="text-normal"
      >
        {callResultFormatted}
      </Grid.Column>
      <Grid.Column
        style={{ ...removeGridPadding }}
        textAlign="right"
        width={5}
        className="text-normal"
      >
        {formatSecondsWithQualifier(duration.toString())}
      </Grid.Column>
    </Grid>
  );
}

RelatedCallsDisplay.propTypes = {
  relatedCalls: PropTypes.instanceOf(Array),
};

RelatedCallsDisplay.defaultProps = {
  relatedCalls: null,
};

RenderRelatedCallLineItem.propTypes = {
  type: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  callResult: PropTypes.string,
  callResultFormatted: PropTypes.string,
  duration: PropTypes.number.isRequired,
};

RenderRelatedCallLineItem.defaultProps = {
  callResult: null,
  callResultFormatted: null,
};
